import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { BaseLayerNames } from 'map/layers'

import { MapContextMenu, MapState } from '../model/map'

const initialState: MapState = {
  baseLayerName: BaseLayerNames.OMV,
  contextMenu: {},
  isTrafficEnabled: false,
}

const mapSlice = createSlice({
  initialState,
  name: 'map',
  reducers: {
    setBaseLayerName(state: MapState, action: PayloadAction<BaseLayerNames>) {
      return produce(state, (draft) => {
        draft.baseLayerName = action.payload
      })
    },
    setContextMenu(state: MapState, action: PayloadAction<MapContextMenu>) {
      return produce(state, (draft) => {
        draft.contextMenu = action.payload
      })
    },
    setIsTrafficEnabled(state: MapState, action: PayloadAction<boolean>) {
      return produce(state, (draft) => {
        draft.isTrafficEnabled = action.payload
      })
    },
  },
})

export const { setBaseLayerName, setContextMenu, setIsTrafficEnabled } = mapSlice.actions

export const reducer = mapSlice.reducer
